import styled from 'styled-components'
import Image from '../../../siteBuilder/blocks/core/Image/Image'
import media from '../../utils/responsiveBreakpoints'

import { SIZES } from '../../utils/constants'

export type ImagesLayoutProps = {
  alignItems?: string
}

export type TallerImageContainerProps = {
  spacingOnTop?: string
}

export type StyledImageProps = {
  description: string
}

const LAYOUT_WIDTH = {
  md: 480,
  lg: 629,
  xl: 768,
}

const TALL_IMAGE_WIDTH_RATIO = 0.59
const SMALL_IMAGE_WIDTH_RATIO = 0.38

type CalculateHeight = (width: number, publishDate: number) => number

const calculateHeight: CalculateHeight = (width, aspectRatio) => {
  return width / aspectRatio
}

export const ImagesLayout = styled.div<ImagesLayoutProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-self: center;
  @media screen and (min-width: ${SIZES.md}px) {
    flex-direction: row;
    align-items: ${(props) => props.alignItems || 'center'};
    justify-content: space-between;
    & > div:not(:last-child) {
      margin-right: 1rem;
    }
  }
`

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  & img {
    height: 408px;
  }
  & > img:not(:first-child) {
    margin-top: 3rem;
  }
  ${{
    ...media.from('md').css({
      width: `${LAYOUT_WIDTH.md * SMALL_IMAGE_WIDTH_RATIO}px`,
      '& img': {
        height: `${calculateHeight(LAYOUT_WIDTH.md * SMALL_IMAGE_WIDTH_RATIO, 1.33)}px`, // maintain 4:3 aspect ratio (width / 1.33)
      },
      '& > img:not(:first-child)': {
        marginTop: '5rem',
      },
    }),
  }}
  ${{
    ...media.from('lg').css({
      width: `${LAYOUT_WIDTH.lg * SMALL_IMAGE_WIDTH_RATIO}px`, // 292px
      '& img': {
        height: `${calculateHeight(LAYOUT_WIDTH.lg * SMALL_IMAGE_WIDTH_RATIO, 1.33)}px`, // maintain 4:3 aspect ratio (width / 1.33)
      },
    }),
  }}
  ${{
    ...media.from('xl').css({
      width: `${LAYOUT_WIDTH.xl * SMALL_IMAGE_WIDTH_RATIO}px`,
      '& img': {
        height: `${calculateHeight(LAYOUT_WIDTH.xl * SMALL_IMAGE_WIDTH_RATIO, 1.33)}px`, // maintain 4:3 aspect ratio (width / 1.33)
      },
    }),
  }}
`

export const StyledImage = styled(Image)<StyledImageProps>`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const TallerImageContainer = styled.div<TallerImageContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
  justify-content: center;
  & > img {
    height: 408px;
  }
  margin-top: 3rem;
  @media screen and (min-width: ${SIZES.md}px) {
    width: ${LAYOUT_WIDTH.md * TALL_IMAGE_WIDTH_RATIO}px;
    margin-top: ${(props) => props.spacingOnTop || '0'};
    & > img {
      height: ${calculateHeight(
        LAYOUT_WIDTH.md * TALL_IMAGE_WIDTH_RATIO,
        1.33
      )}px; // maintain 4:3 aspect ratio (width / 1.33)
    }
  }
  ${{
    ...media.from('lg').css({
      width: `${LAYOUT_WIDTH.lg * TALL_IMAGE_WIDTH_RATIO}px`,
      '& > img': {
        height: `${calculateHeight(LAYOUT_WIDTH.lg * TALL_IMAGE_WIDTH_RATIO, 1.33)}px`, // maintain 4:3 aspect ratio (width / 1.33)
      },
    }),
  }}
  ${{
    ...media.from('xl').css({
      width: `${LAYOUT_WIDTH.xl * TALL_IMAGE_WIDTH_RATIO}px`,
      '& > img': {
        height: `${calculateHeight(LAYOUT_WIDTH.xl * TALL_IMAGE_WIDTH_RATIO, 1.33)}px`, // maintain 4:3 aspect ratio (width / 1.33)
      },
    }),
  }}
`

export const StyledImageCaption = styled.div`
  width: 100%;
  margin-top: 1rem;
  padding-left: 1rem;
  border-left: solid 4px #4b286d;
`
